// @flow weak

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { compose, defaultProps, pure } from 'recompose';

import 'app/common/components/AsyncIndicator.scss';

import type { HOC } from 'recompose';

import type { KindType } from 'app/common/types';

type AsyncIndicatorProps = {
  height?: number,
  kind?: KindType,
  width?: number,
  className?: string,
};

const AsyncIndicator = props => {
  const bem = bemify('async-indicator');
  const className = bem(props.className, toModifiers(props.kind));

  const { height, width } = props;
  // Use `width` since that should always be the widest dimension.
  const dotSize = width / 10;
  const dotProps = {
    className: bem('__dot'),
    cy: height / 2,
    r: dotSize,
  };
  const dotXs = [dotSize, width / 2, width - dotSize];
  const circles = dotXs.map((x, i) => (
    <circle
      {...dotProps}
      cx={x}
      key={i}
      key={i}
      style={{ transformOrigin: `${x}px ${dotProps.cy}px` }}
    />
  ));

  return (
    <svg className={className} height={height} width={width}>
      {circles}
    </svg>
  );
};

const defaultPropsValue = {
  height: 25,
  width: 25,
};

const enhanceAsyncIndicator: HOC<*, AsyncIndicatorProps> = compose(
  pure,
  defaultProps(defaultPropsValue)
);

export default enhanceAsyncIndicator(AsyncIndicator);
